import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import {
  IconButton,
  withTheme,
} from "@material-ui/core";
import {
  getTimeDifferenceInMinutes,
  convertMinutesintoHours,
} from "../utils/utils";
import { Refresh } from "@material-ui/icons";
import appConstants from "../../../../appConstants";
import { utcToZonedTime } from "date-fns-tz";
import { observer, inject } from "mobx-react";

const styles = (theme) => ({
    lastUpdateStatusBar: {
      background: theme.warningBGColor,
      fontSize:theme.dispatchCardTextFontSize,
      padding: "10px",
      color: theme.warningTextColorDispatch,
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      verticalAlign: "middle",
      justifyContent:"flex-end"
    },
    refreshIcon: {
      fontSize: 20,
      color:theme.warningTextColorDispatch,
      fontWeight: "bold",
      textDecorationLine: 'underline',
    },
    refreshText:{
      fontSize: theme.textFontSize,
      textDecorationLine: 'underline',
      color: theme.warningTextColorDispatch,
      fontWeight: "bold",
    },
    lastRefreshButton: {
      padding:'0px',
      marginLeft:'auto'
    },
  });
 
// this component will display when we detect that the last data refresh happens before given thresholdDiffTime(in min) 
// will give the user to option refresh data manually
@inject("DispatchStore")
@observer
class RefreshWarningBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastRefreshTimeDifference: 0,
    };
    this.intervaltimer = null;
    this.lastConnectedTime = null;
  }
  componentDidMount() {
    this.lastConnectedTime = this.props.DispatchStore.driverLocations[this.props.driverId]?.lastConnectedTime;
    this.displayRefreshBar();
    this.getTimeDifference();
  }
  componentDidUpdate() {
    const lastRefreshTime =
      this.props.DispatchStore.driverLocations[this.props.driverId]?.lastConnectedTime;
    if (lastRefreshTime && this.lastConnectedTime !== lastRefreshTime) {
      this.lastConnectedTime = lastRefreshTime;
      this.getTimeDifference();
    }
  }
  componentWillUnmount() {
    if (this.intervaltimer) {
      clearInterval(this.intervaltimer);
      this.intervaltimer = null;
    }
  }

  displayRefreshBar = () => {
    this.intervaltimer = setInterval(() => {
      this.getTimeDifference();
    }, appConstants.REFRESH_DRIVER_DURATION);
  };

  getTimeDifference = () => {
    if (this.lastConnectedTime) {
      const timeArr = this.lastConnectedTime?.split(":");
      const today = utcToZonedTime(new Date(), this.props.terminalOffset);
      this.setState({
        lastRefreshTimeDifference: getTimeDifferenceInMinutes(
          new Date(0, 0, 0, timeArr[0], timeArr[1]),
          new Date(0, 0, 0, today.getHours(), today.getMinutes())
        ),
      });
    } else {
      this.setState({ lastRefreshTimeDifference: 0 });
    }
  };

  onRefreshClick=()=>{
       this.props.onRefreshClick();
       this.setState({ lastRefreshTimeDifference: 0 });
  }

  render() {
    const { classes} = this.props;
    if (!this.lastConnectedTime) {
      return null;
    }
    return (
      <React.Fragment>
        {this.state.lastRefreshTimeDifference >= appConstants.MIN_LAST_REFRESH_THRESHOLD_TIME ? (
          <div className={classes.lastUpdateStatusBar}>
            <span>
             {`Last updated 
              ${convertMinutesintoHours(this.state.lastRefreshTimeDifference)} 
              ago. Refresh the list to view updated information.`}
            </span>
            <IconButton
              className={classes.lastRefreshButton}
              onClick={this.onRefreshClick}
            >
              <Refresh className={classes.refreshIcon} />
              <span className={classes.refreshText}>
              Refresh
            </span>
            </IconButton>
            
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}
export default compose(
  withTheme(),
  withStyles(styles)
)(RefreshWarningBar);
